export function TourStepContent({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
